import qs from 'qs';
import fileDownload from 'react-file-download';
import AdminConstants from 'constants/AdminConstants.js';
import DataFetcher from 'components/modules/shipments/data-fetcher';
import SessionStore from 'stores/SessionStore';
import client from './rest/AdminClient';
import AdminServerActionCreators from '../actions/AdminServerActionCreators';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';

const ActionTypes = AdminConstants.ActionTypes;

const EQUIPMENT_CSV_FILENAME = 'equipment.csv';
const DEFAULT_PAGE_NUMBER = 1;
const defaultQueryOptions = {
  sort: true,
  sort_by: 'equipment_id',
  order: 'asc',
  per_page: 20,
  lean: true,
};

export function getAllEquipmentsByEquipId(ids) {
  let url = `/api/equipments`;
  return client({
    method: 'POST',path:url, entity: JSON.stringify({equipment_ids: ids})
  })
}

export function getAllEquipment(params = {}) {
  const query = { ...defaultQueryOptions, ...params };
  const queryString = qs.stringify(query);
  let BASE_URL = `/api/v2/equipment?${queryString}`;
  if (SessionStore.isAdmin()) {
    BASE_URL = `/admin/api/v2/equipment?${queryString}`;
  }
  return client({
    method: 'GET',
    path: BASE_URL,
  });
}

const getEquipmentAuditEvents = (id) =>
  client({
    method: 'GET',
    path: `/api/audits/equipments/${id}`,
  });

export function bulkAddEquipment(equipment) {
  return client({
    method: 'POST',
    path: '/admin/api/v2/equipment/bulk',
    entity: JSON.stringify(equipment),
  });
}

export function checkEquipmentExists(equipEntity) {
  return client({
    method: 'POST',
    path: '/api/v2/equipment/exists',
    entity: JSON.stringify(equipEntity),
  });
}

export function checkEquipmentExistsInBulk(equipEntities) {
  return client({
    method: 'POST',
    path: '/api/v2/equipment/exists/bulk',
    entity: JSON.stringify(equipEntities),
  });
}

function addEquipment(equipEntity) {
  return client({
    method: 'POST',
    path: '/api/v2/equipment',
    entity: JSON.stringify(equipEntity),
  });
}
function updateEquipment(equipment) {
  return client({
    method: 'PATCH',
    path: '/admin/api/v2/equipment/' + equipment._id,
    entity: JSON.stringify(equipment),
  });
}

function bulkUpdateEquipments(equipments) {
  return client({
    method: 'PUT',
    path: '/admin/api/v2/equipment/bulk',
    entity: JSON.stringify(equipments),
  });
}

function downloadEquipmentCsv(query, activeColumns) {
  const body = {
    query,
    activeColumns,
  };
  return client({
    method: 'POST',
    // TODO change this endpoint when back end is finished
    path: '/elastic-search/csv-from-query',
    entity: JSON.stringify(body),
  });
}

const API = {
  getAllEquipment(query) {
    getAllEquipment(query).then(
      (response) => {
        AdminServerActionCreators.receiveAllEquipment(response.entity);
      },
      (response) => {
        console.error('Failed to retrieve equipment: ', response);
      },
    );
  },
  getEquipmentAuditEvents(id) {
    getEquipmentAuditEvents(id).then(
      (response) => {
        AdminServerActionCreators.receiveEquipmentAuditSuccess({
          id,
          response: response.entity,
        });
      },
      (response) => {
        console.log('Failed to get event audits', response);
      },
    );
  },
  searchEquipment(query) {
    return getAllEquipment(query);
  },
  downloadEquipmentCsv(filters, limit, activeColumns, callback) {
    const query = DataFetcher.buildSearchQuery(
      filters,
      DEFAULT_PAGE_NUMBER,
      limit,
    );
    downloadEquipmentCsv(query, activeColumns).then((response) => {
      fileDownload(response.entity, EQUIPMENT_CSV_FILENAME);
      callback();
    });
  },

  addEquipmentForStagingStop(equipEntity) {
    addEquipment(equipEntity).then(
      (response) => {
        AdminServerActionCreators.addEquipmentForStagingStopSuccess(
          response.entity,
        );
      },
      (response) => {
        AdminServerActionCreators.addEquipmentFail(response.entity);
      },
    );
  },
  addEquipment(equipEntity) {
    addEquipment(equipEntity).then(
      (response) => {
        AdminServerActionCreators.addEquipment(response.entity);
      },
      (response) => {
        AdminServerActionCreators.addEquipmentFail(response.entity);
      },
    );
  },
  updateEquipment(equipment) {
    updateEquipment(equipment).then(
      (response) => {
        AdminServerActionCreators.updateEquipment(response.entity);
      },
      (response) => {
        AdminServerActionCreators.updateEquipmentFail(response.entity);
      },
    );
  },
  bulkUpdateEquipments(equipments) {
    bulkUpdateEquipments(equipments).then(
      (response) => {
        AdminServerActionCreators.bulkUpdateEquipments(response.entity);
      },
      (response) => {
        AdminServerActionCreators.bulkUpdateEquipmentsFail(response.entity);
      },
    );
  },
};

AdminAppDispatcher.register((payload) => {
  const action = payload.action || {};
  const type = action.type;

  switch (type) {
    case ActionTypes.ADD_EQUIPMENT_FOR_STAGING_STOP_REQUEST:
      API.addEquipmentForStagingStop(action.equipment);
      break;
    default:
      break;
  }
});

export default API;
